import type { ComponentPropsWithoutRef, ReactNode } from "react";

import { FormLabel as BaseFormLabel } from "@pbz/ui-kit";

interface FormLabelProps
  extends Omit<ComponentPropsWithoutRef<typeof BaseFormLabel>, "children"> {
  required?: boolean;
  children?: ReactNode;
}

export function FormLabel({ required, children, ...props }: FormLabelProps) {
  return (
    <BaseFormLabel {...props}>
      {children}
      {required && <span className="text-red-500 ml-1">*</span>}
    </BaseFormLabel>
  );
}
